export class ClosurePeriodSettingPostRequest {
  closureStartDate: string
  closureEndDate: string
  memo?: string

  constructor(closureStartDate: string, closureEndDate: string, memo?: string) {
    this.closureStartDate = closureStartDate
    this.closureEndDate = closureEndDate
    this.memo = memo
  }
}
